"use client";

import { TypeProductCollection } from "@contentful/types";
import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
} from "@yardzen/ui/components/carousel";
import { H1 } from "@yardzen/ui/components/h1";
import { ImageWithAvatarCard } from "@yardzen/ui/components/image-with-avatar-card";
import { P } from "@yardzen/ui/components/p";

export function PackageCardsWithDetails({
  packageCollection,
}: {
  packageCollection: TypeProductCollection<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  const { heading, subHeading, designPackage = [] } = packageCollection.fields;
  const allPackages =
    (designPackage?.length || 0) < 6
      ? [
          ...(designPackage || []),
          ...(designPackage || []),
          ...(designPackage || []),
        ]
      : designPackage || [];

  return (
    <div
      id={packageCollection.fields.anchorLinkId || packageCollection.sys.id}
      className="bg-brand-beige-light flex flex-col items-center overflow-hidden pb-12 text-center"
    >
      <H1 className="text-brand-secondary-dark px-12 pt-12 md:px-4">
        {heading}
      </H1>
      <P className="text-brand-moss-greens-90 w-[90%] px-12 pb-8 text-base md:min-w-[37%] md:max-w-[65%] md:px-4 md:text-xl">
        {subHeading}
      </P>
      <Carousel
        className="px-4"
        opts={{
          loop: true,
        }}
      >
        <CarouselContent aria-live="off" className="pb-6">
          {allPackages &&
            allPackages.map((design, index) => {
              const designPackageInfo = design?.fields.package?.fields;
              const imageUrl =
                designPackageInfo?.previewImage?.fields.image?.fields.file
                  ?.url || "";
              const alt =
                designPackageInfo?.previewImage?.fields.image?.fields
                  .description || "";
              const avatarUrl =
                designPackageInfo?.previewImage?.fields.avatar?.fields.file
                  ?.url || "";
              const avatarAlt =
                designPackageInfo?.previewImage?.fields.avatar?.fields
                  .description || "";

              return (
                <CarouselItem key={index} className="basis-1/4">
                  <ImageWithAvatarCard
                    className="h-full"
                    imageUrl={imageUrl}
                    imageAlt={alt}
                    avatarUrl={avatarUrl}
                    avatarAlt={avatarAlt}
                    cardHeading={designPackageInfo?.fullPackageName}
                    cardSubheading={
                      designPackageInfo?.previewImage?.fields?.avatar?.fields
                        ?.title
                    }
                    linkUrl={designPackageInfo?.packagePath}
                    linkText={designPackageInfo?.linkCta || "VIEW DETAILS"}
                    pricing={designPackageInfo?.price?.toString()}
                    strikeThroughPrice={designPackageInfo?.promoPrice?.toString()}
                  />
                </CarouselItem>
              );
            })}
        </CarouselContent>
        <CarouselDots
          count={allPackages?.length || 0}
          dotClassName="border-brand-secondary-dark h-2.5 w-2.5 rounded-full"
          selectedDotClassName="border-brand-secondary-dark bg-brand-secondary-dark h-2.5 w-2.5 rounded-full"
        />
      </Carousel>
    </div>
  );
}
